import 'babel-polyfill';
import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app'

const root = document.getElementById('mzStoreRoot');
ReactDOM.render(<App />, root);



// WEBPACK FOOTER //
// ./src/index.js